import {
    transporterContract
  } from "@/utils/constants";

  import {
    handleError,
    handleResponse
  } from "@/utils/functions";
  
  export default (axios) => ({
    getTransporterContractList(params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .get(transporterContract.transporterContractBase, {
            params: params,
          })
          .then((res) => {
            resolve(handleResponse(res));
          })
          .catch((err) => {
            reject(handleError(err));
          });
      });
    },
    addTransporterContract(data) {
      return new Promise((resolve, reject) => {
        axios
          .post(transporterContract.transporterContractBase, data)
          .then((res) => {
            resolve(handleResponse(res));
          })
          .catch((err) => {
            reject(handleError(err));
          });
      });
    },
    closeTransporterContract(payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${transporterContract.transporterContractBase}${payload.id}/close_contract/`, payload)
          .then((res) => {
            resolve(handleResponse(res));
          })
          .catch((err) => {
            reject(handleError(err));
          });
      });
    },
    getTransporterContractObject(id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${transporterContract.transporterContractBase}${id}/`)
          .then((res) => {
            resolve(handleResponse(res));
          })
          .catch((err) => {
            reject(handleError(err));
          });
      });
    },
    getTransporterContractDetails(id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${transporterContract.transporterContractBase}${id}/view/`)
          .then((res) => {
            resolve(handleResponse(res));
          })
          .catch((err) => {
            reject(handleError(err));
          });
      });
    },
    updateTransporterContract(payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            `${transporterContract.transporterContractBase}${payload.id}/`,
            payload.data
          )
          .then((res) => {
            resolve(handleResponse(res));
          })
          .catch((err) => {
            reject(handleError(err));
          });
      });
    },
    partiallyUpdateTransporterContract(payload) {
      return new Promise((resolve, reject) => {
        axios
          .patch(
            `${transporterContract.transporterContractBase}${payload.id}/`,
            payload.data
          )
          .then((res) => {
            resolve(handleResponse(res));
          })
          .catch((err) => {
            reject(handleError(err));
          });
      });
    },
    getTransporterContractOptions() {
      return new Promise((resolve, reject) => {
        axios
          .options(transporterContract.transporterContractBase)
          .then((res) => {
            resolve(handleResponse(res));
          })
          .catch((err) => {
            reject(handleError(err));
          });
      });
    },
    renewContract(payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${transporterContract.transporterContractBase}${payload.id}/renew_contract/`,
            payload.data
          )
          .then((res) => {
            resolve(handleResponse(res));
          })
          .catch((err) => {
            reject(handleError(err));
          });
      });
    },
    getTransporterContractLogs(id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${transporterContract.transporterContractBase}${id}/logs/`)
          .then((res) => { resolve(handleResponse(res)); })
          .catch((err) => { reject(handleError(err)); });
      });
    },
    getTransporterContractRateList(params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .get(transporterContract.transporterContractRateBase, { params })
          .then((res) => { resolve(handleResponse(res)); })
          .catch((err) => { reject(handleError(err)); });
      });
    },
    addTransporterContractRate(data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${transporterContract.transporterContractRateBase}`, data)
          .then((res) => { resolve(handleResponse(res)); })
          .catch((err) => { reject(handleError(err)); });
      });
    },
    updateTransporterContractRate(payload) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`${transporterContract.transporterContractRateBase}${payload.id}/`, payload.data)
          .then((res) => { resolve(handleResponse(res)); })
          .catch((err) => { reject(handleError(err)); });
      });
    },
    deleteTransporterContractRate(id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${transporterContract.transporterContractRateBase}${id}/`)
          .then((res) => { resolve(handleResponse(res)); })
          .catch((err) => { reject(handleError(err)); });
      });
    },
    getTransporterContractChargeList(params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .get(transporterContract.transporterContractChargeBase, { params })
          .then((res) => { resolve(handleResponse(res)); })
          .catch((err) => { reject(handleError(err)); });
      });
    },
    addTransporterContractCharge(data) {
      return new Promise((resolve, reject) => {
        axios
          .post(transporterContract.transporterContractChargeBase, data)
          .then((res) => { resolve(handleResponse(res)); })
          .catch((err) => { reject(handleError(err)); });
      });
    },
    updateTransporterContractCharge(payload) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`${transporterContract.transporterContractChargeBase}${payload.id}/`, payload.data)
          .then((res) => { resolve(handleResponse(res)); })
          .catch((err) => { reject(handleError(err)); });
      });
    },
    deleteTransporterContractCharge(id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${transporterContract.transporterContractChargeBase}${id}/`)
          .then((res) => { resolve(handleResponse(res)); })
          .catch((err) => { reject(handleError(err)); });
      });
    },
    bulkUploadVendorContracts(data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${transporterContract.transporterContractBase}bulk_upload_vendor_contracts/`, data)
          .then((res) => { resolve(handleResponse(res)); })
          .catch((err) => { reject(handleError(err)); });
      });
    },
  });